if (!customElements.get('cart-block-layout')) {
  class CartBlockLayout extends HTMLElement {
    constructor() {
      super();
      this.mediaQuery = window.matchMedia('(min-width: 990px)');
      this.handleBreakpointChange = this.arrange.bind(this);
    }

    connectedCallback() {
      this.orderedList = this.querySelector('[data-cart-block-list]');
      this.source = this.querySelector('.cart-block-layout__source');
      this.hydrateBlocks();

      this.blocks = Array.from(this.orderedList?.children || []);
      this.blocks.forEach((block, index) => {
        block.dataset.cartBlockOrder = index;
      });

      this.mediaQuery.addEventListener('change', this.handleBreakpointChange);
      this.arrange();
    }

    disconnectedCallback() {
      this.mediaQuery.removeEventListener('change', this.handleBreakpointChange);
    }

    hydrateBlocks() {
      if (!this.orderedList || !this.source) return;

      ['gift', 'upsell', 'heading', 'items', 'summary'].forEach((key) => {
        const target = this.orderedList.querySelector(`[data-cart-block-key="${key}"]`);
        if (!target) return;

        this.source.querySelectorAll(`[data-cart-block-content="${key}"]`).forEach((content) => {
          content.removeAttribute('data-cart-block-content');
          target.appendChild(content);
        });
      });

      this.source.remove();
    }

    arrange() {
      if (!this.orderedList || !this.blocks) return;

      if (!this.mediaQuery.matches) {
        this.blocks
          .sort((a, b) => Number(a.dataset.cartBlockOrder) - Number(b.dataset.cartBlockOrder))
          .forEach((block) => this.orderedList.appendChild(block));
        this.desktopLayout?.remove();
        this.desktopLayout = null;
        return;
      }

      if (!this.desktopLayout) {
        this.desktopLayout = document.createElement('div');
        this.desktopLayout.className = 'cart-container cart-block-layout__desktop';
        this.mainColumn = document.createElement('div');
        this.mainColumn.className = 'cart-block-layout__column cart-block-layout__column--main';
        this.sidebarColumn = document.createElement('div');
        this.sidebarColumn.className = 'cart-block-layout__column cart-block-layout__column--sidebar';
        this.desktopLayout.append(this.mainColumn, this.sidebarColumn);
        this.appendChild(this.desktopLayout);
      }

      this.blocks
        .sort((a, b) => Number(a.dataset.cartBlockOrder) - Number(b.dataset.cartBlockOrder))
        .forEach((block) => {
          const column = block.dataset.cartBlockPosition === 'main' ? this.mainColumn : this.sidebarColumn;
          column.appendChild(block);
        });
    }
  }

  customElements.define('cart-block-layout', CartBlockLayout);
}
